"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPaymentMethods = void 0;
const tslib_1 = require("tslib");
const PaymentMethod_1 = require("@wix/cashier-core/dist/src/services/PaymentMethod");
const getAccountId_1 = require("./getAccountId");
const fetchPaymentMethods = (params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { baseURL, appDefId, appInstanceId, auth } = params;
    const paymentMethodsService = new PaymentMethod_1.PaymentMethodService(Object.assign({ baseURL }, auth));
    const paymentMethods = yield paymentMethodsService.fetchExpressPaymentMethods((0, getAccountId_1.getAccountId)(appDefId, appInstanceId));
    return paymentMethods;
});
exports.fetchPaymentMethods = fetchPaymentMethods;
//# sourceMappingURL=fetchPaymentMethods.js.map